"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DropEvent = /** @class */ (function () {
    function DropEvent(event, data) {
        this.nativeEvent = event;
        this.dragData = data;
    }
    return DropEvent;
}());
exports.DropEvent = DropEvent;
//# sourceMappingURL=drop-event.model.js.map


// WEBPACK FOOTER //
// ./node_modules/ng-drag-drop/src/shared/drop-event.model.js.pre-build-optimizer.js